import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

import svgDivider from '../assets/svg/Membran_Divider.svg'

const HDivider = styled.div`
    width: 1.5em;
    height: 0.05em;
    background-color: red;
    margin: auto;
    margin-top: 25px;
    margin-bottom: 25px;    
`
const VDivider = styled.div`
    width: 0.15em;
    height: 5em;
    background-color: red;
    margin: auto;
`

export { HDivider, VDivider } 


// WEBPACK FOOTER //
// ./src/components/divider.js